import React from 'react';
import { Field, reduxForm } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { injectIntl } from 'react-intl';
import {
  Row, Col, Form, Button, Container,
} from 'reactstrap';

import Input from '../components/Input';
import { LoadingIcon } from '../components/Loading';

const validate = (values) => {
  const errors = {};
  if (isEmpty(values.name)) {
    errors.name = 'Enter name';
  }
  if (/^\d{10}$/.test(values.phoneM1) === false && !isEmpty(values.phoneM1)) {
    errors.phoneM1 = 'Please check mobile number 1 (M1)';
  }
  if (/^\d{10}$/.test(values.phoneM2) === false && !isEmpty(values.phoneM2)) {
    errors.phoneM2 = 'Please check mobile number 2 (M2)';
  }

  return errors;
};

let ClientForm = (props) => {
  const {
    handleSubmit,
    submitting,
    isLoading,
    submitLabel,
    handleCancel,
    showCancel,
  } = props;

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Field
          component={Input}
          name="name"
          type="name"
          label="Name"
          disabled={submitting || isLoading}
          required
        />
        <Field
          component={Input}
          name="email1"
          type="email"
          label="Email (1)"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="email2"
          type="email"
          label="Email (2)"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="address"
          type="address"
          label="Address"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="pincode"
          type="pincode"
          label="Pincode"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="city"
          type="city"
          label="City"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="state"
          type="state"
          label="State"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="phoneR"
          type="tel"
          label="Phone (R)"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="phoneM1"
          type="tel"
          label="Phone (M1)"
          disabled={submitting || isLoading}
        />
        <Field
          component={Input}
          name="phoneM2"
          type="tel"
          label="Phone (M2)"
          disabled={submitting || isLoading}
        />

        {showCancel ? (
          <Row className="mb-3">
            <Col sm={{ size: 4, offset: 1 }}>
              <Button
                type="submit"
                color="primary"
                disabled={submitting || isLoading}
                block
              >
                {submitLabel}
              </Button>
            </Col>
            <Col sm={{ size: 4, offset: 1 }}>
              <Button
                type="button"
                color="secondary"
                disabled={submitting || isLoading}
                onClick={handleCancel}
                block
              >
              Cancel
              </Button>
            </Col>
          </Row>
        ) : (
          <Button
            type="submit"
            color="primary"
            disabled={submitting || isLoading}
            block
          >
            {isLoading && (
            <LoadingIcon />
            )}
            {submitLabel}
          </Button>
        )}
      </Form>
    </Container>
  );
};

ClientForm = reduxForm({
  form: 'UPDATE_CLIENT',
  validate,
})(ClientForm);

export default injectIntl(ClientForm);
